import React, { useRef, useState, useEffect } from "react";

/**
 * ICSFileUpload component for handling ICS file selection and processing
 * Extracted from AdminConsole.js for reusability across components
 * Maintains same file handling and validation logic
 */
const ICSFileUpload = ({
    onFileSelect,
    isUploading = false,
    uploadStatus = "",
    buttonText = "Browse for iCalendar File",
    buttonClassName = "btn-purple"
}) => {
    const icsFileInputRef = useRef(null);
    const [selectedFileName, setSelectedFileName] = useState("");

    // Clear filename when parent resets uploadStatus to empty
    useEffect(() => {
        if (!uploadStatus) {
            setSelectedFileName("");
        }
    }, [uploadStatus]);

    // Handle file selection - extracted from AdminConsole handleFileSelect
    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setSelectedFileName(file.name);
        console.log("Loading iCal file:", file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const content = e.target.result;
            onFileSelect(content, file.name);
            
            // Clear the file input so user can select another file
            e.target.value = "";
        };

        reader.onerror = (e) => {
            console.error("Error reading file:", e.target.error);
            onFileSelect(null, file.name, `Error reading file: ${e.target.error}`);
        };

        reader.readAsText(file);
    };

    return (
        <div className="admin-console-upload-wrapper">
            <div className="admin-console-file-upload">
                <input
                    ref={icsFileInputRef}
                    type="file"
                    accept=".ics,text/calendar"
                    onChange={handleFileSelect}
                    disabled={isUploading}
                    className="admin-console-file-input"
                    id="ics-file-input"
                />
                <label htmlFor="ics-file-input" className={buttonClassName}>
                    {buttonText}
                </label>
                {selectedFileName && (
                    <span style={{ fontSize: '0.875rem', color: 'var(--dl-color-gray-600)', marginLeft: '12px' }}>
                        {selectedFileName}
                    </span>
                )}
            </div>

            {/* Status display */}
            {uploadStatus && (
                <div
                    className={`admin-console-status ${
                        uploadStatus.includes("Error") ? "error" : "success"
                    }`}
                >
                    {isUploading && <div className="admin-console-spinner"></div>}
                    {uploadStatus}
                </div>
            )}
        </div>
    );
};

export default ICSFileUpload;